import { Component, PuzzleTextArea } from "puzzle";
import { ADD_COMMENTS_PROPS, ADD_COMMENTS_STATE } from "./Types";
import React from "react";
import { TextAreaChangeEvent } from "@progress/kendo-react-inputs";
import LimitedLetterCounter from "../../../../../Submission/sections/Details/TemplateDescription/LimitedLetterCounter";

class AddCommentsDialog<P, S extends Partial<ADD_COMMENTS_STATE>> extends Component<P & ADD_COMMENTS_PROPS, S & ADD_COMMENTS_STATE> {
  protected buttonUpdateAction: string = 'updateFileCommentsDialog';

  static defaultProps: ADD_COMMENTS_PROPS = {
    folder: '',
    submissionId: '',
    targetIds: []
  };

  public state: ADD_COMMENTS_STATE = {
    comment: ''
  };

  /**
   * Adds value field to render props
   */
  protected addValueField = () => {
    return {};
  };

  /**
   * Get comment text
   */
  getCommentText = () => this.state.comment;

  /**
   * Get params for add comment request
   */
  getRequestParams = (requestData: any) => {
    const { folder, submissionId } = this.props;
    let activeFilters = requestData.targetIds ? { targetIds: requestData.targetIds } : requestData;
    const { comment } = this.state;
    let params = {
      activeFilters: {
        folder,
        ...activeFilters
      },
      action: 'SAVED',
      comment: comment
    };
    let notificationData = {
      text: this.translate('commentSaved'),
      icon: true,
      closable: true,
      type: 'success'
    };

    return { params, notificationData, submissionId };
  }

  /**
   * Text area change event. Save value to state
   * @param event
   */
  onTextAreaChange = (event: TextAreaChangeEvent) => {
    let { value: comment } = event;
    this.updateToolbar(comment);

    this.setState({
      comment
    });
  };

  /**
   * Update dialog toolbar
   * @param comment
   */
  updateToolbar = (comment: string) => {
    const { comment: oldComment } = this.state;
    if (!!comment && !oldComment) {
      this.dispatch(this.buttonUpdateAction, '', { disableSaveButton: false });
    } else if (!comment && !!oldComment) {
      this.dispatch(this.buttonUpdateAction, '', { disableSaveButton: true });
    }
  };

  renderBody = () => {
    return (
      <>
        <PuzzleTextArea
          maxLength={1000}
          onChange={this.onTextAreaChange}
          placeholder={this.translate('addComment')}
          {...this.addValueField()}
        />
        <LimitedLetterCounter
          className={'tp-color-light'}
          stringToCount={this.state.comment}
          maxCharacters={1000}
        />
      </>

    )
  }
}

export default AddCommentsDialog;